"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const request_1 = require("@shared/request");
const EventRecorder_1 = __importDefault(require("../EventRecorder"));
const CademyEventRecorder_1 = __importDefault(require("../EventRecorder/CademyEventRecorder"));
const SegmentEventRecorder_1 = require("../EventRecorder/SegmentEventRecorder");
class Analytics {
    constructor(options) {
        this.options = options;
        this.destinations = [
            new CademyEventRecorder_1.default(options.baseUrl, new request_1.Request(), options.recordAgainst),
        ];
        if (options.segmentApiKey) {
            this.destinations.push(new SegmentEventRecorder_1.SegmentEventRecorder({
                apiKey: options.segmentApiKey,
                recordedOn: options.recordAgainst,
            }));
        }
        this.record = new EventRecorder_1.default(this.destinations);
    }
}
exports.Analytics = Analytics;
exports.default = Analytics;
